import React from'react';
import Button from'../components/ui/Button';

interface UseCaseSectionProps {}

const UseCasesSection = ({}: UseCaseSectionProps) => {
  const industries = [
    { name: "Oil & Gas / Construction", detail: "$2T+ annual payments globally", badge: "TOP PICK", badgeColor: "bg-red-500" },
    { name: "International Trade", detail: "$6T+ trade finance gap", badge: "HIGH VALUE", badgeColor: "bg-purple-500" },
    { name: "Real Estate", detail: "AED 760B+ Dubai transactions", badge: "HIGH VALUE", badgeColor: "bg-purple-500" },
    { name: "Banking & Financial Services", detail: "Slow settlements, high fees, and lack of transparency in global finance", badge: "HIGH VALUE", badgeColor: "bg-purple-500" },
    { name: "M&A / Earn-outs", detail: "KPI-tied milestone tranches", badge: "MEDIUM", badgeColor: "bg-green-500" },
    { name: "Government Procurement", detail: "Anti-corruption transparency", badge: "MEDIUM", badgeColor: "bg-green-500" },
  ]

  return (
    <section className="w-full bg-white py-8 xs:py-12 sm:py-16 lg:py-20">
      <div className="w-full max-w-[1200px] mx-auto px-3 xs:px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center gap-6 xs:gap-8 sm:gap-10 w-full">
          {/* Header */}
          <div className="flex flex-col items-center gap-3 xs:gap-4 w-full max-w-[854px] mx-auto">
            <Button
              text="TARGET INDUSTRIES"
              text_font_size="14"
              text_font_family="DM Sans"
              text_font_weight="600"
              text_line_height="18px"
              text_text_align="center"
              text_text_transform="uppercase"
              fill_background="linear-gradient(180deg,#FF3333 0%, #FF3333 100%)"
              border_border_radius="6px"
              effect_box_shadow="0px 4px 16px rgba(72,28,0,0.25)"
              padding="6px 12px"
              className="w-auto text-[10px] xs:text-xs sm:text-sm text-white"
            />
            
            <h2 className="text-[24px] sm:text-[32px] md:text-[40px] font-semibold leading-snug text-center text-[#141A23] font-poly">
              Target Industries
            </h2>
          </div>

          {/* Industry Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 w-full">
            {industries.map((industry) => (
              <div
                key={industry.name}
                className="flex flex-col gap-3 p-5 sm:p-6 bg-white rounded-xl border border-[#141A231e] hover:border-[#FF3333] transition-all duration-300"
              >
                <div className="flex items-center gap-3">
                  <h3 className="text-base sm:text-lg font-semibold text-[#141A23] font-poly">
                    {industry.name}
                  </h3>
                  <span className={`${industry.badgeColor} text-white text-[10px] font-semibold px-2 py-0.5 rounded font-dm uppercase tracking-wider flex-shrink-0`}>
                    {industry.badge}
                  </span>
                </div>
                <p className="text-sm sm:text-base text-[#141A237f] font-dm">
                  {industry.detail}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default UseCasesSection
